import { to as tos } from 'await-to-js';
import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { isHttp, isPathMatch } from '@/utils/validate';
import { isRelogin } from '@/utils/request';
import { useUserStore } from '@/store/modules/user';
import { useSettingsStore } from '@/store/modules/settings';
import { usePermissionStore } from '@/store/modules/permission';
import { getSafeRedirectPath } from '@/utils';
import { ElMessage } from 'element-plus/es';

NProgress.configure({ showSpinner: false });
const whiteList = ['/login', '/register', '/social-callback', '/register*', '/register/*'];
const dynamicRouteRemovers: Array<() => void> = [];

const isWhiteList = (path: string) => {
  return whiteList.some((pattern) => isPathMatch(pattern, path));
};
router.beforeEach(async (to, _from, next) => {
  // NProgress.start()
  const userStore = useUserStore();
  const permissionStore = usePermissionStore();
  const settingsStore = useSettingsStore();

  if (getToken()) {
    if (to.path === '/login' && !userStore.tenantIdShow) {
      next({ path: '/' });
      NProgress.done();
      return; // 确保跳转后不再执行后续逻辑
    }

    if (isWhiteList(to.path)) {
      next();
      return;
    }

    // 判断角色，加载路由逻辑
    if (userStore.roles.length === 0 && !userStore.tenantIdShow) {
      isRelogin.show = true;

      const [err] = await tos(userStore.getInfo());

      if (err) {
        isRelogin.show = false;
        if (err.code == 1100) {
          await userStore.tenantFn();
          ElMessage.error(err.msg);
          next({ path: '/login' });
          return;
        }
        await userStore.logout();
        ElMessage.error(err?.message || err?.msg || err);
        next({ path: '/' });
        return;
      }
      isRelogin.show = false;

      // 设置标题等
      to.meta.title && settingsStore.setTitle(to.meta.title as string);
      if (getSafeRedirectPath(to.fullPath || '/') === '/') {
        sessionStorage.removeItem('toPath');
      } else {
        sessionStorage.setItem('toPath', JSON.stringify(to));
      }
      sessionStorage.setItem('toPathShow', JSON.stringify({ isShow: router.getRoutes().some((route) => route.path === to.path) }));

      // 新登录会话先移除上一次注册的路由，避免旧账号权限残留
      dynamicRouteRemovers.splice(0).forEach((removeRoute) => removeRoute());
      permissionStore.setActiveCategory({});
      permissionStore.isRoutesLoaded = false;

      // 每次登录都重新请求并注册动态路由
      const accessRoutes = await permissionStore.generateRoutes();
      accessRoutes.forEach((route) => {
        if (!isHttp(route.path)) {
          dynamicRouteRemovers.push(router.addRoute(route));
        }
      });

      permissionStore.isRoutesLoaded = true;

      // 确保新路由生效
      if (to.path === '/' || to.path === '/index') {
        next({ path: permissionStore.fullPath || '/index', replace: true });
      } else if (router.getRoutes().some((route) => route.path === to.path)) {
        next({ ...to, replace: true });
      } else {
        next({ path: permissionStore.fullPath || '/index', replace: true });
      }
    } else if ((to.path === '/' || to.path === '/index') && permissionStore.fullPath && permissionStore.fullPath !== to.path) {
      next({ path: permissionStore.fullPath, replace: true });
    } else {
      next();
    }
  } else if (isWhiteList(to.path)) {
    next();
  } else {
    const redirect = encodeURIComponent(getSafeRedirectPath(to.fullPath || '/'));
    next(`/login?redirect=${redirect}`);
    NProgress.done();
  }
});
router.afterEach(() => {
  NProgress.done();
});
